import React from 'react'
import FormHOC from './FormHOC'
import InputRow from '../elements/InputRow'
import Button from '../elements/Button'
import FancySelectAdvancedRow from '../elements/FancySelectAdvancedRow'
import { mapTitleFields } from '../constants'
import InputRowReadOnly from '../elements/InputRowReadOnly'
import Addressify from '../elements/Addressify'

const options = {
    postUrl: '/api/postUpdateDetails',
    showHideIcon: true,
    success: 'Success! Your details have been successfully updated.'
}
const state = {}

const UpdateDetailsForm = (props) => {

    return (
        <form onSubmit={props.handleSubmit} onKeyDown={props.handleKeyDown}>
            <FancySelectAdvancedRow
                label='Title'
                name='title'
                value={props.values.title}
                errors={props.errors}
                options={mapTitleFields}
                handleChange={props.setDynamicValues}
            />
            <InputRowReadOnly
                label='First Name'
                value={props.values.firstName}
            />
            <InputRowReadOnly
                label='Last Name'
                value={props.values.lastName}
            />
            <InputRow
                label='Phone'
                name='phone'
                value={props.values.phone}
                errors={props.errors}
                handleChange={props.handleInputChange}
            />
            <InputRow
                label='Mobile'
                name='mobile'
                value={props.values.mobile}
                errors={props.errors}
                handleChange={props.handleInputChange}
            />
            <InputRow
                label='Email Address'
                name='email1'
                value={props.values.email1}
                errors={props.errors}
                handleChange={props.handleInputChange}
            />
            <InputRow
                label='Secondary Email Address'
                name='email2'
                value={props.values.email2}
                errors={props.errors}
                handleChange={props.handleInputChange}
            />
            <Addressify
                label='Billing address'
                name='billingAddress'
                value={props.values.billingAddress}
                errors={props.errors}
                handleSetAddress={props.setDynamicValues}
                placeholder='Start typing your billing address'
            />
            <InputRow
                label='Secret Question'
                name='secretQuestion'
                value={props.values.secretQuestion}
                errors={props.errors}
                handleChange={props.handleInputChange}
            />
            <InputRow
                label='Secret Answer'
                name='secretAnswer'
                value={props.values.secretAnswer}
                errors={props.errors}
                handleChange={props.handleInputChange}
                type='password'
                autoComplete='new-password'
            />

            {props.children}

            <div className='mt-4'>
                <Button title='Update details' action={props.handleSubmit} />
            </div>
        </form>
    )
}

export default FormHOC(UpdateDetailsForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/UpdateDetailsForm.js